import React, { Component } from 'react';
import {
  Card,
  Table,
  Popup,
} from 'semantic-ui-react';
import _ from 'lodash';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import hasRESTClient from '../../hocs/has-rest-client';
import { percentFormatted } from '../../utils/formatting';


const formatNumber = (num, numFormat) => {
  if (numFormat) {
    return numeral(num).format(numFormat);
  }
  let format = num > 1000 ? '0.00a' : '0';
  format = (num > 1000000) ? '0.00a' : format;
  return numeral(num).format(format);
};

const performanceBlockStyles = {
  backgroundColor: '#FFEFD5',
};

const totalsRowStyles = {
  fontWeight: 900,
  backgroundColor: '#D2D1D7',
};

class CampaignSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      report: null,
      isLoading: props.isLoading,
      error: null,
    };
  }

  render() {
    const {
      title,
      isLoading,
      campaigns,
    } = this.props;

    const totalReach = _.sumBy(campaigns, 'reachTotal');
    const totalImpressions = _.sumBy(campaigns, 'impressionsTotal');
    const overallAveER = _.sumBy(campaigns, 'aveER') / _.size(campaigns);
    const impsEMVTotal = _.sumBy(campaigns, 'impsEMVTotal');
    const engsEMVTotal = _.sumBy(campaigns, 'engsEMVTotal');

    return (
      <div style={{ marginTop: '40px', clear: 'all' }}>
        <Card color="green" fluid>

          <Card.Content>

            <table width="100%">
              <tr>
                <td width="50%">
                  <h2>{title}</h2>
                </td>
              </tr>
            </table>


          </Card.Content>

          <Card.Content>
            { !isLoading &&
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign="right" width={1}>
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="right" style={performanceBlockStyles} width={1}>
                    Reach
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="right" style={performanceBlockStyles} width={1}>
                    <Popup content="Impressions" trigger={<span>Imps.</span>} />
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="right" style={performanceBlockStyles} width={1}>
                    Avg ER %
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="right" style={performanceBlockStyles} width={1}>
                    <Popup content="Engagements" trigger={<span>EMV Impressions</span>} />
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="right" style={performanceBlockStyles} width={1}>
                    <Popup content="Earned Media Value" trigger={<span>EMV Engagements</span>} />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  _.map(campaigns, campaign => <ReportTableRow
                    key={campaign.id}
                    campaignReport={campaign}
                  />)
                }
              </Table.Body>
              <Table.Footer fullWidth>
                <Table.Row style={totalsRowStyles}>
                  <Table.HeaderCell style={totalsRowStyles}>
                    Totals
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {formatNumber(totalReach)}
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {formatNumber(totalImpressions)}
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {percentFormatted(overallAveER)}%
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    ${formatNumber(impsEMVTotal)}
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    ${formatNumber(engsEMVTotal)}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>}
            {
              isLoading && <p>Loading...</p>
            }
          </Card.Content>
        </Card>
      </div>
    );
  }
}


const ReportTableRow = ({
  campaignReport,
}) => {
  const {
    campaignName,
    impsEMVTotal,
    engsEMVTotal,
    reachTotal,
    impressionsTotal,
    id: campaignId,
    aveER
  } = campaignReport;
  return (
    <Table.Row>
      <Table.Cell>
        <a href={`https://share.dyzio.co/report/${campaignId}/emv`} target="_blank">
          <h3>{campaignName}</h3>
        </a>
      </Table.Cell>
      <Table.Cell style={performanceBlockStyles} textAlign="right">
        {formatNumber(reachTotal)}
      </Table.Cell>
      <Table.Cell style={performanceBlockStyles} textAlign="right">
        {formatNumber(impressionsTotal)}
      </Table.Cell>
      <Table.Cell style={performanceBlockStyles} textAlign="right">
        {percentFormatted(aveER)}%
      </Table.Cell>
      <Table.Cell style={performanceBlockStyles} textAlign="right">
        ${formatNumber(impsEMVTotal)}
      </Table.Cell>
      <Table.Cell style={performanceBlockStyles} textAlign="right">
        ${formatNumber(engsEMVTotal)}
      </Table.Cell>
    </Table.Row>
  );
};


CampaignSummary.propTypes = {
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  campaigns: PropTypes.array,
};

CampaignSummary.defaultProps = {
  isLoading: false,
  campaigns: [],
  showCampaignTitle: true,
};

ReportTableRow.propTypes = {
  campaignReport: PropTypes.object.isRequired,
};

ReportTableRow.defaultProps = {
  showContactedInfluencersValue: true,
  showReviewedInfluencersValue: true,
};
export default compose(hasRESTClient)(CampaignSummary);



/** WEBPACK FOOTER **
 ** ./src/components/campaign-summary/index.js
 **/